angular.module('bmsApp.directives').factory('VisitPhotoSvc', [
	'$rootScope',
	'$modal',
	'CRUDSvc',
	function (
		$rootScope,
		$modal,
		CRUDSvc) {

	return {
		showVisitPhotosModal: function (visitType, visit) {

			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/visit-photo/templates/VisitPhotosModal.html',
				controller: 'VisitPhotosModalCtrl',
				size: 'md',
				scope: $rootScope,
				resolve: {
					visitType: function () {
						return angular.copy(visitType)
					},
					visit: function () {
						return angular.copy(visit)
					},
				}
			});
		},

		index: function (params) {
			return CRUDSvc.get('api/visit-photo/index', params);
		},

		save: function (params) {
			return CRUDSvc.post('api/visit-photo/save', params);
		}
	};

}]);
